import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutAlignLeftRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLayoutAlignLeftRight"><Path d="M3.5 3.5L20.5 3.5V20.5H3.5L3.5 3.5Z" stroke="currentColor"/><Path d="M7.5 7V17" stroke="currentColor"/><Path d="M16.5 7V17" stroke="currentColor"/></CentralIconBase>;
});

export default IconLayoutAlignLeftRight;
